import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AplicacionState, selectAll } from './aplicacion.reducer';
import { AccesoPerfil } from 'src/common/acceso';

export const aplicacionState = createFeatureSelector<AplicacionState>( "aplicacion" );

export const aplicacionAll = createSelector(
    aplicacionState,
    selectAll
);

export const aplicacionFavoritas = createSelector(
    aplicacionAll,
    apps => apps.filter( app => app.marked )
);

export const aplicacionReady = createSelector(
    aplicacionState,
    state => state.ready
)

export const aplicacionPerfiles = ( nombre: string ) => createSelector(
	aplicacionAll,
	aplicacionReady,
	(apps, ready) => {
		let perfiles: AccesoPerfil[];
		if ( ready && apps && apps.length > 0 ) {
			const pizarraApp = apps.find( app => app.nombre == nombre );
			if ( pizarraApp ) {
				perfiles = pizarraApp.perfiles || [];
			}
		} else {
			perfiles = [];
		}
		return perfiles;
	}
);

// Acceso related selectors
export const aplicacionAccesoUrl = createSelector(
	aplicacionState,
	state => state.accesoUrl
);

export const aplicacionAccesoMfTokenPersona = createSelector(
	aplicacionState,
	state => state.accesoMfTokenPersona
);

export const aplicacionAccesoDate = createSelector(
	aplicacionState,
	state => state.accesoDate
);

export const aplicacionAccesoPortalAuditorToken = createSelector(
	aplicacionState,
	state => state.accesoPortalAuditorToken
)

export const aplicacionAccesoIpCliente = createSelector(
	aplicacionState,
	state => state.accesoIpCliente
)

export const aplicacionAccesoHCEToken = createSelector(
	aplicacionState,
	state => state.accesoHceToken
)

export const aplicacionAccesoUsuarioCredToken = createSelector(
	aplicacionState,
	state => state.accesoCredToken
)